import Vue from 'vue';

/*
 |--------------------------------------------------------------------------
 | Vue Config
 |--------------------------------------------------------------------------
 */

// Vue.config.silent = true;
// Vue.config.productionTip = false;
// Vue.config.devtools = false;

/*
 |--------------------------------------------------------------------------
 | Vue Libraries
 |--------------------------------------------------------------------------
*/

import { routes } from '@/router/routes';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
	linkActiveClass: 'active',
	linkExactActiveClass: 'exact-active',
	mode: 'history',
	routes
});

router.beforeEach((to, from, next) => {
	if(to.name === 'home') {
		setTimeout(() => {
			next();
		}, 1000);
	}

	next();
});

import Vuex from 'vuex';

Vue.use(Vuex);

import { actions } from '@/store/actions';
import { getters } from '@/store/getters';
import { mutations } from '@/store/mutations';
import { state } from '@/store/state';

const store = {
	actions,
	getters,
	mutations,
	state
};

/*
 |--------------------------------------------------------------------------
 | Vue Instance
 |--------------------------------------------------------------------------
*/

import '@/assets/scss/style.scss';

import App from '@/pages/app.vue';

import split from 'lodash/split';

Vue.mixin({
	methods: {
		route(route) {
			return (split(this.$route.name, ':').pop() === route ? true : false);
		}
	}
});

new Vue({
	el: '#page',
	router,
	store,
	components: { App },
	render: (h) => h(App),
});
